module.exports = __webpack_public_path__ + "static/media/kissflow.34142c68.jpg";